import { ViewNode } from './ViewNode';
export class ComponentNode extends ViewNode {
    constructor(key) {
        super(key);
        this.key = key;
    }
    init(params) {
        this.params = params;
        if (params.settings) {
            this.setSettings(params.settings);
        }
    }
    build(options) {
        const { builder, context } = options;
        const params = this.params;
        const model = context.getComponentModel(params.componentKey);
        if (!model) {
            return;
        }
        builder.addModel3dNode({
            key: this.key + '_model3d',
            params: {
                url: model.url,
                meshesMaterials: params.meshesMaterials,
                hiddenMeshes: params.hiddenMeshes,
                settings: this.params.settings,
            },
        });
    }
    mount() { }
}
//# sourceMappingURL=ComponentNode.js.map